import React, {useContext } from 'react'
import clsx from 'clsx';
import {v4 as uuid } from 'uuid';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Box,
    Card,
    Divider, 
    Table,
    TableContainer,
    TableBody,
    TableCell,
    TableRow,
    makeStyles,
    TableHead
} from '@material-ui/core';


import UserContext from '../../context/Globales/UserContext';



const useStyles = makeStyles((theme) => ({
    root: {},
    actions: {
      justifyContent: 'flex-end'
    }, 
    FondoTable:{
        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 500,
        //maxWidth: 800
      },
  }));
  const formatterPeso = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP'
  })
const TblDOcumentoPortalchq =({className, ...rest})=>{
    const classes = useStyles();
    const { DatodetalleDocumentpch } = useContext(UserContext);
    const DatosProtestosPch  = DatodetalleDocumentpch != null  ? DatodetalleDocumentpch.DocumentosProtestados : null;  

    return(
        <>
            <h5>{DatodetalleDocumentpch=='ERROR CONSULTA DOCUMENTO PCH' ? 
                'Error al procesar su solicitud, inténtelo mas tarde(INFORME COMERCIAL)' : ''}</h5>
        
        {DatodetalleDocumentpch!=null || DatodetalleDocumentpch!=undefined ? 

        <Card
            className={clsx(classes.root, className)}
            {...rest}
            >
        
                <Divider />
                <TableContainer className={classes.containerTable}>

              
            <PerfectScrollbar>
                <Box >
                    <Table size="small">
                        <TableHead className={classes.FondoTable}>
                        
                        </TableHead>
                        <TableBody>

                        
                            <TableRow>
                                <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Monto Giro:</strong></TableCell>
                                <TableCell align="right">$ {DatodetalleDocumentpch?.ConsultaDocumentos?.MontoGirado!=null ? DatodetalleDocumentpch?.ConsultaDocumentos?.MontoGirado : 0 }</TableCell>
                                <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Monto Codificado(cod):</strong></TableCell>
                                <TableCell align="right">$ {DatodetalleDocumentpch?.ConsultaDocumentos?.MontoCodificado!=null ? DatodetalleDocumentpch?.ConsultaDocumentos?.MontoCodificado : 0 }</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Monto Rechazado:</strong></TableCell>
                                <TableCell align="right">$ {DatodetalleDocumentpch?.ConsultaDocumentos?.MontoRechazado!=null ? DatodetalleDocumentpch?.ConsultaDocumentos?.MontoRechazado: 0 }</TableCell>
                                <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Monto Vencido(cod):</strong></TableCell>
                                <TableCell align="right">$ {DatodetalleDocumentpch?.ConsultaDocumentos?.MontoVencido!= null ? DatodetalleDocumentpch?.ConsultaDocumentos?.MontoVencido : 0}</TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Monto al Día(cod):</strong></TableCell>
                                <TableCell align="right">$ {DatodetalleDocumentpch?.ConsultaDocumentos?.MontoAlDia!=null ? DatodetalleDocumentpch?.ConsultaDocumentos?.MontoAlDia : 0 }</TableCell>
                                <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Monto a Vencer:</strong></TableCell>
                                <TableCell align="right" >$ {DatodetalleDocumentpch?.ConsultaDocumentos?.MontoAVencer!=null ? DatodetalleDocumentpch?.ConsultaDocumentos?.MontoAVencer : 0 }</TableCell>
                            </TableRow>


                        </TableBody>
                       
                    </Table>
                </Box>

            </PerfectScrollbar>
            </TableContainer>
            </Card>
            : ''}

            {DatosProtestosPch!=null ? 
                DatosProtestosPch.CantidadCheques!=null ? 
                    <Card
                        className={clsx(classes.root, className)}
                        {...rest}
                        >

                        <Divider />
                        <TableContainer className={classes.containerTable}>


                            <PerfectScrollbar>
                                <Box >
                                    <Table size="small">
                                        <TableHead className={classes.FondoTable}>
                                            <TableRow>
                                                <TableCell colspan="4"><br/>INFORMACIÓN DE PROTESTOS</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Cantidad :</strong></TableCell>
                                                <TableCell align="right">{DatosProtestosPch.CantidadCheques!=null ? DatosProtestosPch.CantidadCheques : 0 }</TableCell>
                                                <TableCell style={{backgroundColor : '#dedfe3'}}><strong>Monto :</strong></TableCell>
                                                <TableCell align="right">$ {DatosProtestosPch.MontoCheques!=null ? DatosProtestosPch.MontoCheques : 0 }</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell colspan="4">
                                                    <TableContainer className={classes.containerTable}>
                                                        <Table size="small">
                                                            <TableHead className={classes.FondoTable}>
                                                                
                                                                <TableRow>
                                                                <TableCell>#</TableCell>
                                                                    <TableCell>Banco</TableCell>
                                                                    <TableCell>Cta. Cte.</TableCell>
                                                                    <TableCell>Documento</TableCell>
                                                                    <TableCell>Serie</TableCell>
                                                                    <TableCell>Vencimiento</TableCell>
                                                                    <TableCell>Monto</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {DatosProtestosPch && DatosProtestosPch.Documentos?.map((documento, id)=>(
                                                                            <TableRow key={uuid()}>
                                                                                <TableCell>{id+1}</TableCell>
                                                                                <TableCell>{documento.Banco}</TableCell>
                                                                                <TableCell>{documento.CuentaCorriente}</TableCell> 
                                                                                <TableCell>{documento.NumeroCheque}</TableCell> 
                                                                                <TableCell>{documento.Serie}</TableCell>
                                                                                <TableCell>{documento.Vencimiento}</TableCell>
                                                                                <TableCell align="right">$ {documento.Monto}</TableCell>   
                                                                            </TableRow>
                                                                            ))
                                                                }
                                                            </TableBody>    
                                                        </Table>
                                                    </TableContainer>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Box>

                            </PerfectScrollbar>
                        </TableContainer>
                    </Card>
                    : ''
            : ''}

            </>

    );

};

export default TblDOcumentoPortalchq;